import React from "react";
import {
  LocationNameDisplay,
  useLocations,
} from "@adsk/acc-locations-components";
import { useIsLocationInTree } from "../../utils/hooks/locationsHooks";
import { InlineValueDisplay } from "../../utils/components/InlineValueDisplay";

export const LocationDisplay = ({ locationId }: { locationId: string }) => {
  const { isLoading } = useLocations();
  const isLocationInTree = useIsLocationInTree();

  return (
    <InlineValueDisplay
      loading={isLoading}
      empty={!isLocationInTree(locationId)}
    >
      <LocationNameDisplay locationNodeId={locationId} />
    </InlineValueDisplay>
  );
};
